import React from 'react';

const Sidebar = ({ activeView, setActiveView, onOpenCalculator, onOpenFeriados, onOpenSuspensoes }) => {
    
    const navItems = [
        { key: 'dashboard', label: 'Dashboard', icon: 'fa-chart-pie' },
        { key: 'processos', label: 'Processos', icon: 'fa-folder-open' },
        { key: 'tarefas', label: 'Tarefas', icon: 'fa-tasks' },
        { key: 'calendario', label: 'Calendário', icon: 'fa-calendar-alt' },
        { key: 'prazos', label: 'Gestão de Prazos', icon: 'fa-gavel' },
    ];
    
    const prazosSubMenu = [
        { key: 'calculator', label: 'Calculadora', icon: 'fa-calculator', action: onOpenCalculator },
        { key: 'feriados', label: 'Feriados', icon: 'fa-calendar-check', action: onOpenFeriados },
        { key: 'suspensoes', label: 'Suspensões', icon: 'fa-calendar-times', action: onOpenSuspensoes },
    ];

    const handleNavClick = (e, key) => {
        e.preventDefault();
        setActiveView(key);
    };

    return (
        <aside className="w-80 p-6">
            <nav className="sidebar-nav">
                <ul className="space-y-2">
                    {navItems.map(item => (
                        <li key={item.key}>
                            <a href={`#${item.key}`} 
                               onClick={(e) => handleNavClick(e, item.key)}
                               className={`nav-item flex items-center space-x-3 px-4 py-3 text-white ${activeView === item.key ? 'active' : ''}`}>
                                <i className={`fas ${item.icon} w-5`}></i>
                                <span className="font-medium">{item.label}</span>
                            </a>
                            {item.key === 'prazos' && activeView === 'prazos' && (
                               <ul className="pl-8 mt-2 space-y-1">
                                   {prazosSubMenu.map(subItem => (
                                       <li key={subItem.key}>
                                           <button onClick={subItem.action} className="nav-item flex items-center space-x-3 px-4 py-2 text-sm text-gray-300 hover:text-white w-full">
                                               <i className={`fas ${subItem.icon} w-5`}></i>
                                               <span>{subItem.label}</span>
                                           </button>
                                       </li>
                                   ))}
                               </ul>
                            )}
                        </li>
                    ))}
                </ul>
            </nav>
        </aside>
    );
};

export default Sidebar;
